// src/services/CentroService.js
import axios from "axios";
import { N8N_URL } from "../config";
import { extractHtmlFromN8n } from "./utils/n8nResponse";

// fallback (caso não venha html do n8n)
const escapeHtml = (str) =>
  String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

const buildCentroHtml = (payload) => {
  const data = Array.isArray(payload) ? payload[0] : payload || {};
  const obj = data.json ? data.json : data;
  const titulo = obj?.tipo || "Consulta de Ordens no Centro";
  const centro = obj?.centro ?? "-";
  const dataFmt = obj?.data ?? "-";
  const status = obj?.statusFinal ?? "";

  return `
    <div class="markdown">
      <h3>📊 ${escapeHtml(titulo)}</h3>
      <p><strong>Centro:</strong> ${escapeHtml(centro)}</p>
      <p><strong>Data:</strong> ${escapeHtml(dataFmt)}</p>
      ${status ? `<p><em>${escapeHtml(status)}</em></p>` : ""}
    </div>
  `;
};

export const consultarOrdensCentro = async ({ centro, data }) => {
  const payload = { method: "consultar_ordens_centro", payload: { centro, data } };
  try {
    const res = await axios.post(N8N_URL, payload, { timeout: 180000 });

    // tenta extrair html como o n8n está mandando (htmlFinal, html, etc.)
    let reply = extractHtmlFromN8n(res.data);
    if (!reply) {
      // se não vier html, monta um cartão simples a partir do JSON
      reply = buildCentroHtml(res.data);
    }

    // debug útil
    console.log("[CentroService] request:", payload);
    console.log("[CentroService] response:", res.data);
    console.log("[CentroService] reply length:", reply.length);

    return reply;
  } catch (err) {
    if (err.code === "ECONNABORTED") {
      throw new Error("Tempo limite excedido. Tente novamente mais tarde.");
    }
    console.error("Erro ao consultar ordens no centro (n8n):", err);
    throw err;
  }
};